// var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){

//   for (var i in blackoutdatesCollection) {
//     if (typeof blackoutdatesCollection[i] === "function" || (typeof blackoutdatesCollection[i][0] !== "undefined" && blackoutdatesCollection[i][0].indexOf('function') > -1)) {
//     	delete(blackoutdatesCollection[i]);
//     }
   
//   }
//   //delete(blackoutdatesCollection[5]);
//   picker.set('disable', blackoutdatesCollection);
// }
var CROverrideStoreName = true;
var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  
  if (typeof selectedStore !== "undefined" && selectedStore.storeID === 9800) {
      picker.set('max', 30); 
      picker.set('disable', [true, 
                             { from: [2020, 8, 10], to: [2022, 3, 12] }, 
                             { from: [2022, 3, 14], to: [2025, 1, 13] }
                            ]); 

  }	else {
    picker.set('max', 28); 
    var t = new Date()
    var currentDay = t.getDate();
    var currentMonth = t.getMonth();
    var currentyear = t.getFullYear();
    var weekDay = t.getDay();
    var currentHour = t.getHours()

    if (specialProduct7 === true) {
      picker.set('disable', [1,2,3,4,5,6])
      picker.set('max', 6);   
    } else 
    
    if (specialProduct6 === true) {
      picker.set('disable', [true, 
                             { from: [2020, 8, 10], to: [2022, 3, 10] }
                            ]); 
      picker.set('disable', blackoutdatesCollection);
    } else  
    if (specialProduct === true) {
      picker.set('min', 1);   
      picker.set('disable', [true, 
                             { from: [2020, 8, 10], to: [2022, 1,11] }, 
                             { from: [2022, 1, 13], to: [2022, 1, 13] },
                             { from: [2022, 1, 15], to: [2025, 0, 16] }                            
                            ]); 

    }else if (specialProduct3 === true) {
  // 	picker.set('disable', [true, 
  //                            { from: [2020, 8, 10], to: [2022, 1,18] }, 
  //                            { from: [2022, 1, 20], to: [2025, 1, 13] }
  //                           ]); 

      picker.set('disable', [1,2,3,4,5,6])
      picker.set('max', 5);   
    }else if (specialProduct2 === true) {
      picker.set('disable', [1]);
      picker.set('max', 100);   
    }	else {
      picker.set('disable', blackoutdatesCollection);
    }    
  }
  
  
}

document.addEventListener('crJQActivated', function (e) {
  if (specialProduct3 === true && specialProduct6 === true) {
      disableCheckoutButton();
      var tt = setInterval(function(){disableCheckoutButton();}, 1000);
      setTimeout(function() { clearInterval(tt); }, 5000);  
    jqCR('#pickup-container').remove()
    $('[name=update]').before('<div class="js-storepickup-message-2">Oops!  You selected two items that have different pickup dates!  Please create two separate orders.<br>This week’s pastry is available for pickup Saturday, April 9th and our Easter products are available for pickup starting Monday, April 11th.</div>')
  }
  
})



function activateCheckoutButton(){
    document.querySelector('[name=checkout]').disabled = false;
  }

function disableCheckoutButton(){    
    document.querySelector('[name=checkout]').disabled = true;
}
var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  
  if (specialProduct === true ) {
    timepicker.set('min',[9, 0]); 
    timepicker.set('max',[17, 0]); 
//       if(selectedDate.getDate() === 21 && selectedMonth === 0 && selectedDate.getFullYear() === 2022) {
//   		timepicker.set('min',[10, 0]); 
//         timepicker.set('max',[17, 0]); 
// 	  }
  
//       if(selectedDate.getDate() === 22 && selectedMonth === 0 && selectedDate.getFullYear() === 2022) {
//   		timepicker.set('min',[9, 0]); 
//         timepicker.set('max',[12, 0]); 
// 	  }
  }
	
}